import * as React from "react";

const AddIOS = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg2"
    width="2em"
    height="2em"
    viewBox="0 0 24 24"
    fill="none"
    version="1.1"
  >
    <g id="g2" stroke="#000" strokeMiterlimit="10" strokeWidth="1.5">
      <path
        id="path1"
        d="M17.6 4H6.4A2.4 2.4 0 0 0 4 6.4v11.2A2.4 2.4 0 0 0 6.4 20h11.2a2.4 2.4 0 0 0 2.4-2.4V6.4A2.4 2.4 0 0 0 17.6 4Z"
      ></path>
      <path
        id="path2"
        strokeLinecap="round"
        d="M12 16V8m4 4H8"
        display="inline"
      ></path>
    </g>
  </svg>
);

export default AddIOS;
